/**
 * Collection i18n utilities.
 *
 * Collection names are translated using slug-based keys: `collections.names.<slug>`
 * The slug is a stable identifier from the backend (e.g., "buy-the-dip").
 * If a translation key is missing, the original name from the API is used as fallback.
 *
 * Usage: t(`collections.names.${collection.slug}`, { defaultValue: collection.name })
 */

/**
 * Ordered list of section keys (API display names) and their i18n title keys.
 * Preserves the display order of sections on the collections page.
 */
export const ORDERED_SECTIONS: { apiKey: string; titleKey: string }[] = [
  { apiKey: "Don't know where to get started?", titleKey: 'collections.sections.getStarted' },
  { apiKey: 'Follow trends', titleKey: 'collections.sections.followTrends' },
  { apiKey: 'Chase high flyers', titleKey: 'collections.sections.highFlyers' },
  { apiKey: 'Leaderboards', titleKey: 'collections.sections.leaderboards' },
  { apiKey: 'Follow famous investors', titleKey: 'collections.sections.famousInvestors' },
  { apiKey: 'Invest in value', titleKey: 'collections.sections.investValue' },
  { apiKey: 'Find beat-up stocks', titleKey: 'collections.sections.beatUpStocks' },
  { apiKey: 'Invest in specific regions', titleKey: 'collections.sections.regions' },
  { apiKey: 'Invest in a particular sector', titleKey: 'collections.sections.sectors' },
];
